import * as ActionTypes from "./actionTypes";

export const updateResponsive = responsive => ({
	type: ActionTypes.UPDATE_RESPONSIVE,
	isResponsive: responsive,
});

export const toggleSideMenu = showSideMenu => ({
	type: ActionTypes.TOGGLE_SIDE_MENU,
	showSideMenu,
});

export const hideSideMenu = () => ({
	type: ActionTypes.HIDE_SIDE_MENU,
});

export const showSideMenu = () => ({
	type: ActionTypes.SHOW_SIDE_MENU,
});

export const dropdownOpen = () => ({
	type: ActionTypes.DROPDOWN_OPEN,
});

export const dropdownClose = () => ({
	type: ActionTypes.DROPDOWN_CLOSE,
});
